/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsSbomVersionIdQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsSbomVersionIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionIdQueryOperator>): AppSecopsSbomVersionIdQueryOperator {
        let obj = Object.assign(new AppSecopsSbomVersionIdQueryOperator(), model);
        AppSecopsSbomVersionIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionIdQueryOperator>): AppSecopsSbomVersionIdQueryOperator {
        if (!model) return null;
        return AppSecopsSbomVersionIdQueryOperator.newInstance(<AppSecopsSbomVersionIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionIdQueryOperator) {
        if (!obj) return;

        models.AppSecopsSbomVersionIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomVersionIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * SBOM version IDs to include
     */
    sbom_version_ids: Array<string>;

}
